import React from 'react';
import { TrackerList } from './TrackerList.container';
import { TrackerListControls } from './TrackerListControls.container';

export const TrackerListPage: React.FC<{ id?: string }> = () => (
  <>
    <div className="content-title-box without-background">
      <TrackerListControls />
    </div>
    <div className="content-inner flex-one flex-box-column">
      <div className="content panel-content flex-one">
        <TrackerList />
      </div>
    </div>
  </>
);
